import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'contexts/appContext';

export default function Settings(props) {
  return (
    <>
      <div className='settings-container'>
        <ThemeSwitch />
        <LanguageMenu />
      </div>
    </>
  );
}


function ThemeSwitch(props) {
  const { t } = useTranslation();
  const { appState, setAppTheme } = useContext(AppContext);

  const changeTheme = (theme) => {
    setAppTheme(theme);
  }

  return (
    <>
      <div className='section'>
        <h4>{t('Theme')}</h4>
        <ul className='list-group formmenu formmenu-open' >
          <li className='list-group-item formmenu-child linked' onClick={() => changeTheme('light-theme')}>
            <div className='row'>
              <div className='col-10' style={{ fontSize: '14px', paddingTop: '5px' }}>
                {t('Light')}
              </div>
              <div className='col-2 text-right'>
                <label className='checkradio-label' style={{ color: appState.theme === 'light-theme' ? '#5cb85c' : appState.theme === 'nav-theme' ? '#828282' : '#cbcbcb' }} ><i className='icons8-ok' /></label>
              </div>
            </div>
          </li>
          <li className='list-group-item formmenu-child linked' onClick={() => changeTheme('dark-theme')}>
            <div className='row'>
              <div className='col-10' style={{ fontSize: '14px', paddingTop: '5px' }}>
                {t('Dark')}
              </div>
              <div className='col-2 text-right'>
                <label className='checkradio-label' style={{ color: appState.theme === 'dark-theme' ? '#5cb85c' : appState.theme === 'nav-theme' ? '#828282' : '#cbcbcb' }}><i className='icons8-ok' /></label>
              </div>
            </div>
          </li>
          <li className='list-group-item formmenu-child linked' onClick={() => changeTheme('nav-theme')}>
            <div className='row'>
              <div className='col-10' style={{ fontSize: '14px', paddingTop: '5px' }}>
                {t('Nav')}
              </div>
              <div className='col-2 text-right'>
                <label className='checkradio-label' style={{ color: appState.theme === 'nav-theme' ? '#5cb85c' : appState.theme === 'nav-theme' ? '#828282' : '#cbcbcb' }}><i className='icons8-ok' /></label>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}


function LanguageMenu(props) {
  const { t, i18n } = useTranslation();
  const { appState, setAppLang } = useContext(AppContext);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setAppLang(lang);
  };

  return (
    <>
      <div className='section'>
        <h4>{t('Language')}</h4>
        <ul className='list-group formmenu formmenu-open' >
          <li className='list-group-item formmenu-child linked' onClick={() => changeLanguage('en')}>
            <div className='row'>
              <div className='col-10' style={{ fontSize: '14px', paddingTop: '5px' }}>
                English
              </div>
              <div className='col-2 text-right'>
                <label className='checkradio-label' style={{ color: appState.lang === 'en' ? '#5cb85c' : appState.theme === 'nav-theme' ? '#828282' : '#cbcbcb' }}><i className='icons8-ok' /></label>
              </div>
            </div>
          </li>
          <li className='list-group-item formmenu-child linked' onClick={() => changeLanguage('fr')}>
            <div className='row'>
              <div className='col-10' style={{ fontSize: '14px', paddingTop: '5px' }}>
                Français
              </div>
              <div className='col-2 text-right'>
                <label className='checkradio-label' style={{ color: appState.lang === 'fr' ? '#5cb85c' : appState.theme === 'nav-theme' ? '#828282' : '#cbcbcb' }}><i className='icons8-ok' /></label>
              </div>
            </div>
          </li>
          <li className='list-group-item formmenu-child linked' onClick={() => changeLanguage('es')}>
            <div className='row'>
              <div className='col-10' style={{ fontSize: '14px', paddingTop: '5px' }}>
                Español
              </div>
              <div className='col-2 text-right'>
                <label className='checkradio-label' style={{ color: appState.lang === 'es' ? '#5cb85c' : appState.theme === 'nav-theme' ? '#828282' : '#cbcbcb' }}><i className='icons8-ok' /></label>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}